<template>
    <div id="main">
        <div v-show="showForm">
            <div class="listing-header mb-3">
                <div class="title-breadcrumb">
                    <span>
                        <h1 class="title">
                            {{ $t('recomendacao') }}
                        </h1>
                    </span>
                </div>
                <div class="header-buttons">
                    <button class="delete-btn" type="button" @click="fecharModal()">
                        {{ $t('cancelar') }}
                    </button>
                    <button
                        v-if="
                            situacao == 4 &&
                            ((!this.uuid != null && this.permissao.create) ||
                                (this.uuid != null && this.permissao.update))
                        "
                        class="save-btn"
                        type="button"
                        @click="save"
                        :disabled="isLoadingEdit"
                    >
                        {{ $t('salvar') }}
                    </button>
                </div>
            </div>
            <br />

            <div class="form-columns-fit" v-show="!isLoading">
                <div class="columns is-flex-wrap">
                    <div class="column is-6">
                        <vss-select
                            :id="generateId(1)"
                            ref="tiporecomendacaoSelect"
                            title="tipo-recomendacao"
                            :placeholder="
                                produtoSelect.length > 0
                                    ? 'selecione-uma-opcao'
                                    : 'sem-opcao-de-selecao'
                            "
                            searchable
                            :options="tiporecomendacaoSelect"
                            v-model="tiporecomendacaoSelected"
                            :required="true"
                            :invalid="isNull(tiporecomendacaoSelected)"
                            :loading="tiporecomendacaoLoading"
                            @search="loadTipoRecomendacao"
                            @onBlurFunction="sendIsChanged('tiporecomendacao')"
                            :disabled="situacao != 4 || isLoadingEdit"
                        />
                    </div>
                    <div class="column is-6" v-if="permissaoFields.ativaproduto > 0">
                        <vss-select
                            :id="generateId(2)"
                            ref="produtoSelect"
                            title="produto"
                            :placeholder="
                                produtoSelect.length > 0
                                    ? 'selecione-uma-opcao'
                                    : 'sem-opcao-de-selecao'
                            "
                            searchable
                            :options="produtoSelect"
                            v-model="produtoSelected"
                            :required="permissaoFields.ativaproduto == 2"
                            :invalid="permissaoFields.ativaproduto == 2 && isNull(produtoSelected)"
                            :loading="produtoLoading"
                            @search="loadProduto"
                            @onBlurFunction="sendIsChanged('produto')"
                            :disabled="situacao != 4 || isLoadingEdit"
                        />
                    </div>
                </div>
                <div class="columns is-flex-wrap">
                    <div class="column is-4" v-if="permissaoFields.ativaqtde > 0">
                        <v-money
                            :id="generateId(10)"
                            ref="qtdeInput"
                            v-model="recomendacao.qtde"
                            title="quantidade"
                            :required="permissaoFields.ativaqtde == 2"
                            :msg="invalidQtdeMsg"
                            :invalid="invalidQtde"
                            @onBlurFunction="validateQtde()"
                            :min="0"
                            :max="10000"
                            :disabled="situacao != 4 || isLoadingEdit"
                        />
                    </div>
                    <div class="column is-4" v-if="permissaoFields.ativadosagem > 0">
                        <v-money
                            :id="generateId(15)"
                            ref="dosagemInput"
                            v-model="recomendacao.dosagem"
                            title="dosagem"
                            :required="permissaoFields.ativadosagem == 2"
                            :msg="invalidDosagemMsg"
                            :invalid="invalidDosagem"
                            @onBlurFunction="validateDosagem()"
                            :min="0"
                            :max="10000"
                            :disabled="situacao != 4 || isLoadingEdit"
                        />
                    </div>
                    <div class="column is-4" v-if="permissaoFields.ativapressaobico > 0">
                        <v-money
                            :id="generateId(20)"
                            ref="pressaobicosInput"
                            v-model="recomendacao.pressaobicos"
                            title="pressao-bico"
                            :required="permissaoFields.ativapressaobico == 2"
                            :msg="invalidPressaobicosMsg"
                            :invalid="invalidPressaobicos"
                            @onBlurFunction="validatePressaobicos()"
                            :min="0"
                            :max="10000"
                            :disabled="situacao != 4 || isLoadingEdit"
                        />
                    </div>
                    <div class="column is-12" v-if="permissaoFields.ativaformaaplicacao > 0">
                        <v-textarea
                            ref="formaaplicacaoTextarea"
                            :id="generateId(50)"
                            v-model="recomendacao.formaaplicacao"
                            title="forma-aplicacao"
                            placeholder="placeholder-preencha"
                            :required="permissaoFields.ativaformaaplicacao == 2"
                            :invalid="
                                permissaoFields.ativaformaaplicacao == 2 &&
                                isNull(recomendacao.formaaplicacao)
                            "
                            :rows="6"
                            :maxRows="6"
                            :disableTransform="true"
                            :maxlength="500"
                            :icon="situacao != 4 ? null : 'text-box-plus-outline'"
                            iconSvg
                            @input-action="(showForm = false), (showAplicacaoSugestao = true)"
                            :disabled="situacao != 4 || isLoadingEdit"
                        />
                    </div>
                    <div class="column is-12" v-if="permissaoFields.ativadescricaogeral > 0">
                        <v-textarea
                            ref="observacaoTextarea"
                            :id="generateId(50)"
                            v-model="recomendacao.observacao"
                            title="descricao"
                            placeholder="placeholder-preencha"
                            :required="permissaoFields.ativadescricaogeral == 2"
                            :invalid="
                                permissaoFields.ativadescricaogeral == 2 &&
                                isNull(recomendacao.observacao)
                            "
                            :rows="6"
                            :maxRows="6"
                            :disableTransform="true"
                            :maxlength="500"
                            :icon="situacao != 4 ? null : 'text-box-plus-outline'"
                            iconSvg
                            @input-action="(showForm = false), (showDescricaoSugestao = true)"
                            :disabled="situacao != 4 || isLoadingEdit"
                        />
                    </div>
                </div>
            </div>
            <container-loader v-if="isLoading && !$store.getters.isLoading" />
        </div>
        <!-- Forma de aplicação - Sujestão -->
        <AplicacaoSugestaoSelectModal
            v-if="showAplicacaoSugestao"
            @fecharModal="(showForm = true), (showAplicacaoSugestao = false)"
            @selected="aplicacaoSugestaoSelected"
        />
        <!-- Descrição geral - Sujestão -->
        <DescricaoSugestaoSelectModal
            v-if="showDescricaoSugestao"
            @fecharModal="(showForm = true), (showDescricaoSugestao = false)"
            @selected="descricaoSugestaoSelected"
        />
    </div>
</template>

<script>
import RecomendacaoService from '@/services/agro/agrovisita/AgroVisitaItemRecomendacaoService';
import TipoRecomendacaoService from '@/services/agro/TipoRecomendacaoService';
import ProdutoService from '@/services/vendas/produto/ProdutoService.js';
import AplicacaoSugestaoSelectModal from '@/components/agro/agro-visita-item/modal/recomendacao/AplicacaoSugestaoSelectModal';
import DescricaoSugestaoSelectModal from '@/components/agro/agro-visita-item/modal/recomendacao/DescricaoSugestaoSelectModal';
import RecomendacaoValidation from '@/services/validations/agro/RecomendacaoValidation';
import ContainerLoader from '@/components/content/loader/ContainerLoader';

export default {
    components: {
        ContainerLoader,
        AplicacaoSugestaoSelectModal,
        DescricaoSugestaoSelectModal,
    },
    props: {
        uuid: {
            type: String,
            default: null,
        },
        cantEdit: {
            type: Boolean,
            default: false,
        },
        situacao: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            showForm: true,
            showAplicacaoSugestao: false,
            showDescricaoSugestao: false,
            service: new RecomendacaoService(this.$http, this.$router),
            serviceTiporecomendacao: new TipoRecomendacaoService(this.$http, this.$router),
            serviceProduto: new ProdutoService(this.$http, this.$router),
            validation: new RecomendacaoValidation(this.msgs),
            isLoading: false,
            isSaving: false,
            //para controlar algumas ações até os dados serem carregados na edição
            isLoadingEdit: false,
            msgs: [],
            recomendacao: {
                idagro_visitarecomendacaoerp: null,
                uuid: null,
                replicapda: null,
                idagro_tiporecomendacao: null,
                idproduto: null,
                qtde: 0,
                dosagem: 0,
                pressaobicos: 0,
                formaaplicacao: null,
                observacao: null,
                latitude: null,
                longitude: null,
                lastfix: null,
                tipogps: null,
                uuidagro_visitaitem: null,
            },
            permissaoFields: {
                ativaproduto: 0,
                ativadosagem: 0,
                ativapressaobico: 0,
                ativaformaaplicacao: 0,
                ativadescricaogeral: 0,
                ativaqtde: 0,
            },
            permissaoFieldsClean: {},
            tiporecomendacaoSelect: [],
            tiporecomendacaoSelected: null,
            tiporecomendacaoLoading: true,
            produtoSelect: [],
            produtoSelected: null,
            produtoLoading: true,

            invalidQtde: true,
            invalidQtdeMsg: 'msg-campo-obrigatorio',
            invalidDosagem: true,
            invalidDosagemMsg: 'msg-campo-obrigatorio',
            invalidPressaobicos: true,
            invalidPressaobicosMsg: 'msg-campo-obrigatorio',
            permissao: false,
        };
    },
    created() {
        this.$emit('isChangedModal', false);
        this.permissaoFieldsClean = Object.assign({}, this.permissaoFields);
        if (this.uuid != null) this.carregarDados();

        this.permissao = this.hasPermissionAccess('agro', 'agro-visita', 'agro-visita');
    },
    watch: {
        recomendacao: {
            deep: true,
            handler: function () {
                if (!this.isLoadingEdit) {
                    this.$emit('isChangedModal', true);
                }
            },
        },
    },
    methods: {
        generateId(numberId) {
            return this.$route.name + '-recomendacao-' + numberId;
        },
        carregarDados() {
            this.isLoading = true;
            this.isLoadingEdit = true;
            this.service
                .findByUuid(this.uuid)
                .then((value) => {
                    this.recomendacao = Object.assign({}, value.content);
                    this.tiporecomendacaoSelected = {
                        id: this.recomendacao.tiporecomendacao.id,
                        label: this.recomendacao.tiporecomendacao.descricao,
                    };
                    if (this.recomendacao.produto) {
                        this.produtoSelected = {
                            id: this.recomendacao.produto.id,
                            label: this.recomendacao.produto.descricao,
                        };
                    }
                })
                .catch((e) => {
                    console.error(e);
                    this.$root.showMessage('error', 'msg-erro-load', true);
                })
                .finally((_) => {
                    // this.isLoading = false;
                    this.isLoadingEdit = false;
                    setTimeout(() => {
                        this.$emit('isChanged', false);
                    }, 500);
                });
        },
        aplicacaoSugestaoSelected(sugestao) {
            this.recomendacao.formaaplicacao = sugestao;
            this.showForm = true;
            this.showAplicacaoSugestao = false;
        },
        descricaoSugestaoSelected(sugestao) {
            this.recomendacao.observacao = sugestao;
            this.showForm = true;
            this.showDescricaoSugestao = false;
        },
        // Emite ao componente pai se houve alteração em um campo select
        sendIsChanged(label = null) {
            if (!this.isLoadingEdit) this.$emit('isChangedModal', true);

            if (label == 'tiporecomendacao') {
                this.isLoading = true;
                this.permissaoFields = Object.assign({}, this.permissaoFieldsClean);
                if (this.tiporecomendacaoSelected != null) {
                    setTimeout(() => {
                        this.loadTipoRecomendacaoPermissao();
                    }, 300);
                } else {
                    this.isLoading = false;
                }
            }
        },
        fecharModal() {
            this.$emit('fecharModal', true);
        },
        loadTipoRecomendacao(termo = null) {
            if (this.situacao != 4) {
                this.tiporecomendacaoLoading = false;
                return;
            }

            this.tiporecomendacaoLoading = true;

            termo = this.removeToSearch(termo);

            this.serviceTiporecomendacao
                .findAllCombo(termo)
                .then((body) => {
                    return body.content.map((i) => {
                        return {
                            id: i.id,
                            label: i.descricao,
                        };
                    });
                })
                .then((r) => {
                    this.tiporecomendacaoSelect = Object.assign(r);
                })
                .catch((e) => {
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error(`Erro ao realizar pesquisa. Termo: [${termo}]`, e);
                })
                .finally((_) => {
                    this.tiporecomendacaoLoading = false;
                });
        },
        loadTipoRecomendacaoPermissao() {
            this.serviceTiporecomendacao
                .find(this.tiporecomendacaoSelected.id)
                .then((r) => {
                    if (r.content) {
                        this.permissaoFields.ativaproduto = +r.content.ativaproduto;
                        this.permissaoFields.ativadosagem = +r.content.ativadosagem;
                        this.permissaoFields.ativapressaobico = +r.content.ativapressaobico;
                        this.permissaoFields.ativaformaaplicacao = +r.content.ativaformaaplicacao;
                        this.permissaoFields.ativadescricaogeral = +r.content.ativadescricaogeral;
                        this.permissaoFields.ativaqtde = +r.content.ativaqtde;
                    } else {
                        this.permissaoFields = Object.assign({}, this.permissaoFieldsClean);
                        this.$root.showMessage('error', 'msg-erro-load');
                    }
                })
                .catch((e) => {
                    this.$root.showMessage('error', 'msg-erro-load');
                })
                .finally((_) => {
                    this.isLoading = false;
                });
        },
        loadProduto(termo = null) {
            if (this.situacao != 4) {
                this.produtoLoading = false;
                return;
            }

            this.produtoLoading = true;

            termo = this.removeToSearch(termo);

            let params = [
                // Adicionar filtro complementar
                this.isNull(termo) ? '.*' : termo,
                // parâmetro adicional com o id do que deve ser usado no filtro
                this.$route.params.id,
            ];

            this.serviceProduto
                .findAllByAgroVisita(params)
                .then((body) => {
                    return body.content.map((i) => {
                        return {
                            id: i.id,
                            label: i.descricao,
                        };
                    });
                })
                .then((r) => {
                    this.produtoSelect = Object.assign(r);
                })
                .catch((e) => {
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error(`Erro ao realizar pesquisa. Termo: [${termo}]`, e);
                })
                .finally((_) => {
                    this.produtoLoading = false;
                });
        },
        validateQtde() {
            if (this.permissaoFields.ativaqtde == 2 && this.recomendacao.qtde == 0) {
                this.invalidQtde = true;
                this.invalidQtdeMsg = 'msg-campo-obrigatorio';
            } else if (+this.recomendacao.qtde < 0 || +this.recomendacao.qtde > 10000) {
                this.invalidQtde = true;
                this.invalidQtdeMsg = 'msg-campo-invalido';
            } else {
                this.invalidQtde = false;
            }
        },
        validateDosagem() {
            if (this.permissaoFields.ativadosagem == 2 && this.recomendacao.dosagem == 0) {
                this.invalidDosagem = true;
                this.invalidDosagemMsg = 'msg-campo-obrigatorio';
            } else if (+this.recomendacao.dosagem < 0 || +this.recomendacao.dosagem > 10000) {
                this.invalidDosagem = true;
                this.invalidDosagemMsg = 'msg-campo-invalido';
            } else {
                this.invalidDosagem = false;
            }
        },
        validatePressaobicos() {
            if (this.permissaoFields.ativapressaobico == 2 && this.recomendacao.pressaobicos == 0) {
                this.invalidPressaobicos = true;
                this.invalidPressaobicosMsg = 'msg-campo-obrigatorio';
            } else if (
                +this.recomendacao.pressaobicos < 0 ||
                +this.recomendacao.pressaobicos > 10000
            ) {
                this.invalidPressaobicos = true;
                this.invalidPressaobicosMsg = 'msg-campo-invalido';
            } else {
                this.invalidPressaobicos = false;
            }
        },
        successPosition(position) {
            this.recomendacao.latitude = position.coords.latitude ? position.coords.latitude : 0;
            this.recomendacao.longitude = position.coords.longitude ? position.coords.longitude : 0;
            this.recomendacao.lastfix = position.timestamp ? position.timestamp : null;
            this.recomendacao.tipogps = position.coords.latitude ? 1 : 0;
            console.info(position);
        },
        errorPosition(e) {
            console.error('Geolocation error!', e);
        },
        save() {
            this.isLoading = true;
            // pega alocalização através do navegador caso esteja liberado
            if (navigator.geolocation) {
                console.log('Geolocation is supported by this browser');
                navigator.geolocation.getCurrentPosition(this.successPosition, this.errorPosition);
            } else {
                console.log('Geolocation is not supported by this browser');
            }
            setTimeout(() => {
                let recomendacaoTemp = {
                    idagro_visitarecomendacaoerp: this.recomendacao.idagro_visitarecomendacaoerp,
                    uuid: this.recomendacao.uuid,
                    replicapda: this.recomendacao.replicapda,
                    idagro_tiporecomendacao: this.recomendacao.idagro_tiporecomendacao,
                    idproduto: this.recomendacao.idproduto,
                    qtde: this.recomendacao.qtde,
                    dosagem: this.recomendacao.dosagem,
                    pressaobicos: this.recomendacao.pressaobicos,
                    formaaplicacao: this.recomendacao.formaaplicacao,
                    observacao: this.recomendacao.observacao,
                    latitude: this.recomendacao.latitude,
                    longitude: this.recomendacao.longitude,
                    lastfix: this.recomendacao.lastfix,
                    tipogps: this.recomendacao.tipogps,
                    uuidagro_visitaitem: this.recomendacao.uuidagro_visitaitem,
                };
                // monta dados complementares
                recomendacaoTemp.uuidagro_visitaitem = this.$route.params.id;
                recomendacaoTemp.idagro_tiporecomendacao =
                    this.tiporecomendacaoSelected != null ? this.tiporecomendacaoSelected.id : null;
                recomendacaoTemp.idproduto =
                    this.produtoSelected != null ? this.produtoSelected.id : null;

                if (this.validation.validate(recomendacaoTemp, this.permissaoFields, this.$refs)) {
                    recomendacaoTemp = this.mapTosave(
                        recomendacaoTemp,
                        'uuid',
                        'uuidagro_visitaitem'
                    );

                    this.isSaving = true;
                    this.service
                        .save(recomendacaoTemp)
                        .then((value) => {
                            if (value.message == null) {
                                let msg = this.$t(
                                    this.isUpdate ? 'msg-edit-sucesso-n' : 'msg-save-sucesso-n',
                                    { n: this.$t('recomendacao') }
                                );

                                this.$root.showMessage('success', msg, true, false);

                                this.$emit('isChanged', false);
                                this.$emit('save', true);
                            } else {
                                if (this.$t(value.message)) {
                                    this.$root.showMessage('alert', value.message, true);
                                } else {
                                    this.$root.showMessage(
                                        'error',
                                        'msg-problema-realizar-acao',
                                        true
                                    );
                                }
                            }
                        })
                        .catch((e) => {
                            this.$root.showMessage('error', 'msg-problema-realizar-acao', true);
                        })
                        .finally(() => {
                            this.isSaving = false;
                            this.isLoading = false;
                        });
                } else {
                    this.$root.showMessage('alert', 'msg-campos-obrigatorios', true);
                    this.isLoading = false;
                }
            }, 300);
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 20px 20px;
    .in-loader {
        position: relative;
    }
}
</style>
